import React from 'react';

export default () => (
  <svg
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Page 1</title>
    <desc>Created with Sketch.</desc>
    <g
      id="Landing-Pages"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="White-Paper-Form"
        transform="translate(-922.000000, -188.000000)"
        fill="#989898"
      >
        <g id="form" transform="translate(475.000000, 165.000000)">
          <polygon
            id="Page-1"
            points="464.6775 23 456.72375 30.955 448.7675 23 447 24.7675 454.955 32.7225 447 40.67875 448.7675 42.44625 456.72375 34.49125 464.6775 42.44625 466.44625 40.67875 458.49125 32.7225 466.44625 24.7675"
          />
        </g>
      </g>
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/icons/IconClose.jsx